const state = {
    isInfoRequestVisible: false
};

const getters = {
    isInfoRequestVisible: state => state.isInfoRequestVisible
};

const mutations = {
    setInfoRequestVisible: (state, data) => state.isInfoRequestVisible = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    strict: false
};